module.exports = __webpack_public_path__ + "static/img/hkj3.e27a76b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/hkj3.jpg
// module id = jBh+
// module chunks = 0